// extracted by mini-css-extract-plugin
module.exports = {"flex1":"xsiNY6S4JWP4KPjinG0Oc"};